import { FinanceServiceAPI } from '@weave/schema-gen-ts/dist/schemas/finance/finance_service_api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaFinanceV1Service = bindHTTP(FinanceServiceAPI);
export const serviceName = 'finance-v1' as const;
